import constants from 'app/constants'
import fetchJSONData from 'app/util/fetchJSONData'

/**
 *
 * @param {object} props - the config props
 * @param {string} props.wallet - the users wallet address
 * @returns {object} the result
 */
async function getNfts ({ wallet }) {
  const res = await fetchJSONData(
    `${constants.API_V2_URL}/frontend/customers/nfts/owned?wallet=${wallet}&network=${constants.NETWORK}`,
    {
      method: 'GET',
      headers: {
        'company-id': constants.API_ID,
        'Content-Type': 'application/json'
      }
    }
  )

  if (!res.success) {
    return {
      success: false,
      data: {
        avatars: [],
        accessories: [],
        backgrounds: [],
        claimable: []
      }
    }
  }

  return {
    data: res.data,
    success: true
  }
}

// Export
export default getNfts
